import { useTranslation } from 'react-i18next';
import React from 'react';
import { GetCustomerResponse } from '../../../../modules/backend/openapi/api-types';
import { GridContainer, GridItem } from '../../../../visual-components/grid/grid';
import { Link } from '../../../../visual-components/link/link';
import { SectionHeader } from '../../../../visual-components/section-header/section-header';
import { Spacer } from '../../../../visual-components/spacer/spacer';
import { usePathBuilder } from '../../../../core/routing/hooks/use-path-builder';
import { Divider } from '../../../../visual-components/divider/divider';
import { Address } from './address';

type Props = {
  data: GetCustomerResponse;
};

export const AddressList: React.FC<Props> = ({ data: { data: data } }) => {
  const { t } = useTranslation();
  const { formAddressMutation, formNewDeliveryAddress } = usePathBuilder();

  return (
    <>
      <GridContainer>
        <GridItem>
          <Divider />
          <SectionHeader>{t('global.addresses')}</SectionHeader>
        </GridItem>
      </GridContainer>
      <Spacer size="06" />
      <GridContainer>
        <GridItem span="6">
          <Address address={data.invoiceAddress} title={t('global.invoiceAddress')} />
        </GridItem>
      </GridContainer>
      <Spacer size="03" />
      <Spacer size="06" />
      {data.shippingAddresses
        ? data.shippingAddresses.map((address, index) => (
            <GridContainer key={address.addressId}>
              <GridItem span="6">
                <Address
                  address={address}
                  title={
                    t('profile.settings.deliveryAddress', { number: index + 1 }) +
                    (address.isDefault ? ` (${t('profile.settings.default')})` : '')
                  }
                />
              </GridItem>
            </GridContainer>
          ))
        : null}
      <GridContainer>
        <GridItem span="8">
          <Link icon="pen-box" to={formAddressMutation(data.name)}>
            {t('profile.settings.askForAddressMutation')}
          </Link>
        </GridItem>
        <GridItem span="8">
          <Link icon="pen-box" to={formNewDeliveryAddress(data.name)}>
            {t('profile.settings.askForNewDeliveryAddress')}
          </Link>
        </GridItem>
      </GridContainer>
    </>
  );
};
